import { render, staticRenderFns } from "./EnIyiSatis.vue?vue&type=template&id=0b086e98&scoped=true"
import script from "./EnIyiSatis.vue?vue&type=script&lang=js"
export * from "./EnIyiSatis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b086e98",
  null
  
)

export default component.exports